import { default as MuiTypography } from '@mui/material/Typography';
import styledBy from "./util/styledBy";
import React from "react";
import { styled } from './styled';

const StyledType = styled(MuiTypography)(({ theme, ...props }) => ({
  fontFamily: styledBy('fontFamily', {
    serif: 'Merriweather, "Times New Roman"'
  })(props),
  color: styledBy('color', {
    dark: theme.palette.primary.veryDark
  })(props)
}));

export const Typography = React.forwardRef((props, ref) => {
  const {
    ...otherProps
  } = props;
  return <StyledType ref={ref} {...otherProps} />;
});